import React from 'react'

const Ola9 = () => {
    return (
        <div className='container'>
        <h1>Level order traversal in spiral form</h1>
        <p>Write a function to print spiral order traversal of a tree. For below tree, function should print 1, 2, 3, 4, 5, 6, 7. 
</p>
<p><strong>Solution (Recursive)</strong>&nbsp;<br/>

To print the nodes in spiral order, nodes at different levels should be printed in alternating order. An additional Boolean variable <i>ltr </i>is used to change printing order of levels. If <i>ltr </i>is 1 then printGivenLevel() prints nodes from left to right else from right to left. Value of <i>ltr </i>is flipped in each iteration to change the order.<br/>
Function to print level order traversal of tree&nbsp;</p>
<pre className='containers'><strong> <br />
printSpiral(tree)</strong> <br />
bool ltr = 0; <br />
for d = 1 to height(tree) <br />
 printGivenLevel(tree, d, ltr); <br />
 ltr ~= ltr /*flip ltr*/</pre> <br />
 <p>Function to print all nodes at a given level&nbsp;</p>
 <pre className='containers'><strong>printGivenLevel(tree, level, ltr)</strong> <br />
if tree is NULL then return; <br />
if level is 1, then <br />
print(tree-&gt;data); <br />
else if level greater than 1, then <br />
if(ltr) <br />
    printGivenLevel(tree-&gt;left, level-1, ltr); <br />
    printGivenLevel(tree-&gt;right, level-1, ltr); <br />
else <br />
    printGivenLevel(tree-&gt;right, level-1, ltr); <br />
    printGivenLevel(tree-&gt;left, level-1, ltr);</pre> <br />

    <div class="tabs">
<input type="radio" name="tab" id="tab1" />
<label for="tab1">CPP</label>
<input type="radio" name="tab" id="tab2"/>
<label for="tab2">Java </label>
<input type="radio" name="tab" id="tab3"/>
<label for="tab3">Python</label>
<input type="radio" name="tab" id="tab4"/>
<label for="tab4">C</label>


<div class="tab-content-wrapper">
<div id="tab-content-1" class="tab-content">
<div class="container">
<div class="line number1 index0 alt2"><code class="comments">// C++ program for recursive level&nbsp;</code></div>
<div class="line number2 index1 alt1"><code class="comments">// order traversal in spiral form</code></div>
<div class="line number3 index2 alt2"><code class="preprocessor">#include&lt;bits/stdc++.h&gt;</code></div>
<div class="line number4 index3 alt1"><code class="keyword bold">using</code> <code
        class="keyword bold">namespace</code> <code class="plain">std;</code></div>
<div class="line number5 index4 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number6 index5 alt1"><code class="comments">// A binary tree node has data,&nbsp;</code></div>
<div class="line number7 index6 alt2"><code class="comments">// pointer to left child and a</code></div>
<div class="line number8 index7 alt1"><code class="comments">// pointer to right child&nbsp;</code></div>
<div class="line number9 index8 alt2"><code class="keyword bold">struct</code> <code class="plain">node</code></div>
<div class="line number10 index9 alt1"><code class="plain">&#123;</code></div>
<div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">data;</code></div>
<div class="line number12 index11 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">node* left;</code></div>
<div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">node* right;</code></div>
<div class="line number14 index13 alt1"><code class="plain">&#125;;</code></div>
<div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number16 index15 alt1"><code class="comments">// Function protoypes&nbsp;</code></div>
<div class="line number17 index16 alt2"><code class="keyword bold">void</code> <code
        class="plain">printGivenLevel(</code><code class="keyword bold">struct</code> <code
        class="plain">node* root,&nbsp;</code></div>
<div class="line number18 index17 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">level, </code><code class="color1 bold">int</code> <code
        class="plain">ltr);</code></div>
<div class="line number19 index18 alt2"><code class="color1 bold">int</code> <code class="plain">height(</code><code
        class="keyword bold">struct</code> <code class="plain">node* node);</code></div>
<div class="line number20 index19 alt1"><code class="keyword bold">struct</code> <code
        class="plain">node* newNode(</code><code class="color1 bold">int</code> <code class="plain">data);</code>
</div>
<div class="line number21 index20 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number22 index21 alt1"><code
        class="comments">// Function to print spiral traversal of a tree</code></div>
<div class="line number23 index22 alt2"><code class="keyword bold">void</code> <code
        class="plain">printSpiral(</code><code class="keyword bold">struct</code> <code
        class="plain">node* root)</code></div>
<div class="line number24 index23 alt1"><code class="plain">&#123;</code></div>
<div class="line number25 index24 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">h = height(root);</code></div>
<div class="line number26 index25 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">i;</code></div>
<div class="line number27 index26 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number28 index27 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// ltr -&gt; Left to Right. If this variable</code></div>
<div class="line number29 index28 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// is set,then the given level is traversed&nbsp;</code></div>
<div class="line number30 index29 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// from left to right.&nbsp;</code></div>
<div class="line number31 index30 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">bool</code> <code class="plain">ltr = </code><code
        class="keyword bold">false</code><code class="plain">;</code></div>
<div class="line number32 index31 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">for</code><code class="plain">(i = 1; i &lt;= h; i++)</code></div>
<div class="line number33 index32 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number34 index33 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">printGivenLevel(root, i, ltr);</code></div>
<div class="line number35 index34 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number36 index35 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Revert ltr to traverse next&nbsp;</code></div>
<div class="line number37 index36 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// level in opposite order</code></div>
<div class="line number38 index37 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">ltr = !ltr;</code></div>
<div class="line number39 index38 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number40 index39 alt1"><code class="plain">&#125;</code></div>
<div class="line number41 index40 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number42 index41 alt1"><code class="comments">// Print nodes at a given level&nbsp;</code></div>
<div class="line number43 index42 alt2"><code class="keyword bold">void</code> <code
        class="plain">printGivenLevel(</code><code class="keyword bold">struct</code> <code
        class="plain">node* root,&nbsp;</code></div>
<div class="line number44 index43 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">level, </code><code class="color1 bold">int</code> <code
        class="plain">ltr)</code></div>
<div class="line number45 index44 alt2"><code class="plain">&#123;</code></div>
<div class="line number46 index45 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(root == NULL)</code></div>
<div class="line number47 index46 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code><code class="plain">;</code></div>
<div class="line number48 index47 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(level == 1)</code></div>
<div class="line number49 index48 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">cout &lt;&lt; root-&gt;data &lt;&lt; </code><code class="string">" "</code><code
        class="plain">;</code></div>
<div class="line number50 index49 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number51 index50 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">else</code> <code class="keyword bold">if</code> <code
        class="plain">(level &gt; 1)&nbsp;</code></div>
<div class="line number52 index51 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number53 index52 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(ltr)</code></div>
<div class="line number54 index53 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code>
</div>
<div class="line number55 index54 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">printGivenLevel(root-&gt;left,&nbsp;</code></div>
<div class="line number56 index55 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">level - 1, ltr);</code></div>
<div class="line number57 index56 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">printGivenLevel(root-&gt;right,</code></div>
<div class="line number58 index57 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">level - 1, ltr);</code></div>
<div class="line number59 index58 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
</div>
<div class="line number60 index59 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">else</code>&nbsp;</div>
<div class="line number61 index60 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code>
</div>
<div class="line number62 index61 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">printGivenLevel(root-&gt;right,&nbsp;</code></div>
<div class="line number63 index62 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">level - 1, ltr);</code></div>
<div class="line number64 index63 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">printGivenLevel(root-&gt;left,</code></div>
<div class="line number65 index64 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">level - 1, ltr);</code></div>
<div class="line number66 index65 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
</div>
<div class="line number67 index66 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number68 index67 alt1"><code class="plain">&#125;</code></div>
<div class="line number69 index68 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number70 index69 alt1"><code
        class="comments">// Compute the "height" of a tree -- the number of</code></div>
<div class="line number71 index70 alt2"><code
        class="comments">// nodes along the longest path from the root node</code></div>
<div class="line number72 index71 alt1"><code class="comments">// down to the farthest leaf node.</code></div>
<div class="line number73 index72 alt2"><code class="color1 bold">int</code> <code class="plain">height(</code><code
        class="keyword bold">struct</code> <code class="plain">node* node)</code></div>
<div class="line number74 index73 alt1"><code class="plain">&#123;</code></div>
<div class="line number75 index74 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(node == NULL)</code></div>
<div class="line number76 index75 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">0;</code></div>
<div class="line number77 index76 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">else</code>&nbsp;</div>
<div class="line number78 index77 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number79 index78 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number80 index79 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Compute the height of each subtree&nbsp;</code></div>
<div class="line number81 index80 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">lheight = height(node-&gt;left);</code></div>
<div class="line number82 index81 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">rheight = height(node-&gt;right);</code></div>
<div class="line number83 index82 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number84 index83 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Use the larger one&nbsp;</code></div>
<div class="line number85 index84 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(lheight &gt; rheight)</code></div>
<div class="line number86 index85 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">(lheight + 1);</code></div>
<div class="line number87 index86 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">else</code></div>
<div class="line number88 index87 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">(rheight + 1);</code></div>
<div class="line number89 index88 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number90 index89 alt1"><code class="plain">&#125;</code></div>
<div class="line number91 index90 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number92 index91 alt1"><code class="comments">// Helper function that allocates a new&nbsp;</code>
</div>
<div class="line number93 index92 alt2"><code class="comments">// node with the given data and NULL left</code>
</div>
<div class="line number94 index93 alt1"><code class="comments">// and right pointers.&nbsp;</code></div>
<div class="line number95 index94 alt2"><code class="keyword bold">struct</code> <code
        class="plain">node* newNode(</code><code class="color1 bold">int</code> <code class="plain">data)</code>
</div>
<div class="line number96 index95 alt1"><code class="plain">&#123;</code></div>
<div class="line number97 index96 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">node* newnode = </code><code class="keyword bold">new</code> <code
        class="plain">node();</code></div>
<div class="line number98 index97 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">newnode-&gt;data = data;</code></div>
<div class="line number99 index98 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">newnode-&gt;left = NULL;</code></div>
<div class="line number100 index99 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">newnode-&gt;right = NULL;</code></div>
<div class="line number101 index100 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number102 index101 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">(newnode);</code></div>
<div class="line number103 index102 alt2"><code class="plain">&#125;</code></div>
<div class="line number104 index103 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number105 index104 alt2"><code class="comments">// Driver code</code></div>
<div class="line number106 index105 alt1"><code class="color1 bold">int</code> <code class="plain">main()</code>
</div>
<div class="line number107 index106 alt2"><code class="plain">&#123;</code></div>
<div class="line number108 index107 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">node* root = newNode(1);</code></div>
<div class="line number109 index108 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">root-&gt;left = newNode(2);</code></div>
<div class="line number110 index109 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">root-&gt;right = newNode(3);</code></div>
<div class="line number111 index110 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">root-&gt;left-&gt;left = newNode(7);</code></div>
<div class="line number112 index111 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">root-&gt;left-&gt;right = newNode(6);</code></div>
<div class="line number113 index112 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">root-&gt;right-&gt;left = newNode(5);</code></div>
<div class="line number114 index113 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">root-&gt;right-&gt;right = newNode(4);</code></div>
<div class="line number115 index114 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="functions bold">printf</code><code class="plain">(</code><code
        class="string">"Spiral Order traversal of "</code>&nbsp;</div>
<div class="line number116 index115 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="string">"binary tree is \n"</code><code class="plain">);</code></div>
<div class="line number117 index116 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;
</div>
<div class="line number118 index117 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">printSpiral(root);</code></div>
<div class="line number119 index118 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number120 index119 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">0;</code></div>
<div class="line number121 index120 alt2"><code class="plain">&#125;</code></div>
<div class="line number122 index121 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number123 index122 alt2"><code class="comments">// This code is contributed by samrat2825</code>
</div>
</div>
</div>
<div id="tab-content-2" class="tab-content">
<div class="container">
<div class="line number1 index0 alt2"><code
        class="comments">// Java program for recursive level order traversal in spiral form</code></div>
<div class="line number2 index1 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number3 index2 alt2"><code
        class="comments">/* A binary tree node has data, pointer to left child&nbsp;</code></div>
<div class="line number4 index3 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
        class="comments">and a pointer to right child */</code></div>
<div class="line number5 index4 alt2"><code class="keyword">class</code> <code class="plain">Node &#123;</code></div>
<div class="line number6 index5 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">int</code> <code class="plain">data;</code></div>
<div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node left, right;</code></div>
<div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">public</code> <code class="plain">Node(</code><code class="keyword">int</code> <code
        class="plain">d)</code></div>
<div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number11 index10 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">data = d;</code></div>
<div class="line number12 index11 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">left = right = </code><code class="keyword">null</code><code class="plain">;</code></div>
<div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number14 index13 alt1"><code class="plain">&#125;</code></div>
<div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number16 index15 alt1"><code class="keyword">class</code> <code class="plain">BinaryTree &#123;</code>
</div>
<div class="line number17 index16 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node root;</code></div>
<div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Function to print the spiral traversal of tree</code></div>
<div class="line number20 index19 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">void</code> <code class="plain">printSpiral(Node node)</code></div>
<div class="line number21 index20 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number22 index21 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">int</code> <code class="plain">h = height(node);</code></div>
<div class="line number23 index22 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">int</code> <code class="plain">i;</code></div>
<div class="line number24 index23 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number25 index24 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* ltr -&gt; left to right. If this variable is set then the</code></div>
<div class="line number26 index25 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">given label is traversed from left to right */</code></div>
<div class="line number27 index26 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">boolean</code> <code class="plain">ltr = </code><code class="keyword">false</code><code
        class="plain">;</code></div>
<div class="line number28 index27 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">for</code> <code class="plain">(i = </code><code class="value">1</code><code
        class="plain">; i &lt;= h; i++) &#123;</code></div>
<div class="line number29 index28 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">printGivenLevel(node, i, ltr);</code></div>
<div class="line number30 index29 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number31 index30 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/*Revert ltr to traverse next level in opposite order*/</code></div>
<div class="line number32 index31 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">ltr = !ltr;</code></div>
<div class="line number33 index32 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
</div>
<div class="line number34 index33 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number35 index34 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number36 index35 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* Compute the "height" of a tree -- the number of</code></div>
<div class="line number37 index36 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">nodes along the longest path from the root node</code></div>
<div class="line number38 index37 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">down to the farthest leaf node.*/</code></div>
<div class="line number39 index38 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">int</code> <code class="plain">height(Node node)</code></div>
<div class="line number40 index39 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number41 index40 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">(node == </code><code class="keyword">null</code><code
        class="plain">)</code></div>
<div class="line number42 index41 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="value">0</code><code class="plain">;</code></div>
<div class="line number43 index42 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">else</code> <code class="plain">&#123;</code></div>
<div class="line number44 index43 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number45 index44 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* compute the height of each subtree */</code></div>
<div class="line number46 index45 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">int</code> <code class="plain">lheight = height(node.left);</code></div>
<div class="line number47 index46 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">int</code> <code class="plain">rheight = height(node.right);</code></div>
<div class="line number48 index47 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number49 index48 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* use the larger one */</code></div>
<div class="line number50 index49 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">(lheight &gt; rheight)</code></div>
<div class="line number51 index50 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">(lheight + </code><code class="value">1</code><code
        class="plain">);</code></div>
<div class="line number52 index51 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">else</code></div>
<div class="line number53 index52 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">(rheight + </code><code class="value">1</code><code
        class="plain">);</code></div>
<div class="line number54 index53 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
</div>
<div class="line number55 index54 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number56 index55 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number57 index56 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* Print nodes at a given level */</code></div>
<div class="line number58 index57 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">void</code> <code class="plain">printGivenLevel(Node node, </code><code
        class="keyword">int</code> <code class="plain">level, </code><code class="keyword">boolean</code> <code
        class="plain">ltr)</code></div>
<div class="line number59 index58 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number60 index59 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">(node == </code><code class="keyword">null</code><code
        class="plain">)</code></div>
<div class="line number61 index60 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code><code class="plain">;</code></div>
<div class="line number62 index61 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">(level == </code><code class="value">1</code><code
        class="plain">)</code></div>
<div class="line number63 index62 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">System.out.print(node.data + </code><code class="string">" "</code><code
        class="plain">);</code></div>
<div class="line number64 index63 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">else</code> <code class="keyword">if</code> <code class="plain">(level &gt; </code><code
        class="value">1</code><code class="plain">) &#123;</code></div>
<div class="line number65 index64 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">(ltr != </code><code class="keyword">false</code><code
        class="plain">) &#123;</code></div>
<div class="line number66 index65 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">printGivenLevel(node.left, level - </code><code class="value">1</code><code
        class="plain">, ltr);</code></div>
<div class="line number67 index66 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">printGivenLevel(node.right, level - </code><code class="value">1</code><code
        class="plain">, ltr);</code></div>
<div class="line number68 index67 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number69 index68 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">else</code> <code class="plain">&#123;</code></div>
<div class="line number70 index69 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">printGivenLevel(node.right, level - </code><code class="value">1</code><code
        class="plain">, ltr);</code></div>
<div class="line number71 index70 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">printGivenLevel(node.left, level - </code><code class="value">1</code><code
        class="plain">, ltr);</code></div>
<div class="line number72 index71 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number73 index72 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
</div>
<div class="line number74 index73 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number75 index74 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* Driver program to test the above functions */</code></div>
<div class="line number76 index75 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">public</code> <code class="keyword">static</code> <code class="keyword">void</code> <code
        class="plain">main(String[] args)</code></div>
<div class="line number77 index76 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number78 index77 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">BinaryTree tree = </code><code class="keyword">new</code> <code
        class="plain">BinaryTree();</code></div>
<div class="line number79 index78 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">tree.root = </code><code class="keyword">new</code> <code class="plain">Node(</code><code
        class="value">1</code><code class="plain">);</code></div>
<div class="line number80 index79 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">tree.root.left = </code><code class="keyword">new</code> <code class="plain">Node(</code><code
        class="value">2</code><code class="plain">);</code></div>
<div class="line number81 index80 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">tree.root.right = </code><code class="keyword">new</code> <code
        class="plain">Node(</code><code class="value">3</code><code class="plain">);</code></div>
<div class="line number82 index81 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">tree.root.left.left = </code><code class="keyword">new</code> <code
        class="plain">Node(</code><code class="value">7</code><code class="plain">);</code></div>
<div class="line number83 index82 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">tree.root.left.right = </code><code class="keyword">new</code> <code
        class="plain">Node(</code><code class="value">6</code><code class="plain">);</code></div>
<div class="line number84 index83 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">tree.root.right.left = </code><code class="keyword">new</code> <code
        class="plain">Node(</code><code class="value">5</code><code class="plain">);</code></div>
<div class="line number85 index84 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">tree.root.right.right = </code><code class="keyword">new</code> <code
        class="plain">Node(</code><code class="value">4</code><code class="plain">);</code></div>
<div class="line number86 index85 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">System.out.println(</code><code
        class="string">"Spiral order traversal of Binary Tree is "</code><code class="plain">);</code></div>
<div class="line number87 index86 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">tree.printSpiral(tree.root);</code></div>
<div class="line number88 index87 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number89 index88 alt2"><code class="plain">&#125;</code></div>
<div class="line number90 index89 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number91 index90 alt2"><code
        class="comments">// This code has been contributed by Mayank Jaiswal(mayank_24)</code></div>
</div>
</div> 
<div id="tab-content-3" class="tab-content">
<div class="container">
<div class="line number1 index0 alt2"><code class="comments"># Python3 program for recursive level order</code>
</div>
<div class="line number2 index1 alt1"><code class="comments"># traversal in spiral form&nbsp;</code></div>
<div class="line number3 index2 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number4 index3 alt1"><code class="keyword">class</code> <code class="plain">newNode:&nbsp;</code>
</div>
<div class="line number5 index4 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number6 index5 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># Construct to create a newNode&nbsp;</code></div>
<div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">def</code> <code class="plain">__init__(</code><code class="color1">self</code><code
        class="plain">, key):&nbsp;</code></div>
<div class="line number8 index7 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1">self</code><code class="plain">.data </code><code class="keyword">=</code> <code
        class="plain">key&nbsp;</code></div>
<div class="line number9 index8 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1">self</code><code class="plain">.left </code><code class="keyword">=</code> <code
        class="color1">None</code></div>
<div class="line number10 index9 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1">self</code><code class="plain">.right </code><code class="keyword">=</code> <code
        class="color1">None</code></div>
<div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number12 index11 alt1"><code
        class="comments">""" Function to print spiral traversal of a tree"""</code></div>
<div class="line number13 index12 alt2"><code class="keyword">def</code> <code
        class="plain">printSpiral(root):</code></div>
<div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">h </code><code class="keyword">=</code> <code class="plain">height(root)&nbsp;</code></div>
<div class="line number16 index15 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;
</div>
<div class="line number17 index16 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">"""ltr Left to Right. If this variable&nbsp;</code></div>
<div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">is set, then the given level is traversed</code></div>
<div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">from left to right. """</code></div>
<div class="line number20 index19 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">ltr </code><code class="keyword">=</code> <code class="color1">False</code></div>
<div class="line number21 index20 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">for</code> <code class="plain">i </code><code class="keyword">in</code> <code
        class="functions">range</code><code class="plain">(</code><code class="value">1</code><code
        class="plain">, h </code><code class="keyword">+</code> <code class="value">1</code><code
        class="plain">):</code></div>
<div class="line number22 index21 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;
</div>
<div class="line number23 index22 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">printGivenLevel(root, i, ltr)&nbsp;</code></div>
<div class="line number24 index23 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number25 index24 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">"""Revert ltr to traverse next level</code></div>
<div class="line number26 index25 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">in opposite order"""</code></div>
<div class="line number27 index26 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">ltr </code><code class="keyword">=</code> <code class="keyword">not</code> <code
        class="plain">ltr&nbsp;</code></div>
<div class="line number28 index27 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;
</div>
<div class="line number29 index28 alt2"><code class="comments">""" Print nodes at a given level """</code></div>
<div class="line number30 index29 alt1"><code class="keyword">def</code> <code
        class="plain">printGivenLevel(root, level, ltr):</code></div>
<div class="line number31 index30 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number32 index31 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code><code class="plain">(root </code><code class="keyword">=</code><code
        class="keyword">=</code> <code class="color1">None</code><code class="plain">):</code></div>
<div class="line number33 index32 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code></div>
<div class="line number34 index33 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code><code class="plain">(level </code><code class="keyword">=</code><code
        class="keyword">=</code> <code class="value">1</code><code class="plain">):</code></div>
<div class="line number35 index34 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">print</code><code class="plain">(root.data, end </code><code class="keyword">=</code> <code
        class="string">" "</code><code class="plain">)&nbsp;</code></div>
<div class="line number36 index35 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">elif</code> <code class="plain">(level &gt; </code><code class="value">1</code><code
        class="plain">):</code></div>
<div class="line number37 index36 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;
</div>
<div class="line number38 index37 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code><code class="plain">(ltr):</code></div>
<div class="line number39 index38 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">printGivenLevel(root.left, level </code><code class="keyword">-</code> <code
        class="value">1</code><code class="plain">, ltr)&nbsp;</code></div>
<div class="line number40 index39 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">printGivenLevel(root.right, level </code><code class="keyword">-</code> <code
        class="value">1</code><code class="plain">, ltr)&nbsp;</code></div>
<div class="line number41 index40 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number42 index41 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">else</code><code class="plain">:</code></div>
<div class="line number43 index42 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">printGivenLevel(root.right, level </code><code class="keyword">-</code> <code
        class="value">1</code><code class="plain">, ltr)&nbsp;</code></div>
<div class="line number44 index43 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">printGivenLevel(root.left, level </code><code class="keyword">-</code> <code
        class="value">1</code><code class="plain">, ltr)&nbsp;</code></div>
<div class="line number45 index44 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number46 index45 alt1"><code
        class="comments">""" Compute the "height" of a tree -- the number of&nbsp;</code></div>
<div class="line number47 index46 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">nodes along the longest path from the root node&nbsp;</code></div>
<div class="line number48 index47 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">down to the farthest leaf node."""</code></div>
<div class="line number49 index48 alt2"><code class="keyword">def</code> <code class="plain">height(node):</code>
</div>
<div class="line number50 index49 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number51 index50 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">(node </code><code class="keyword">=</code><code
        class="keyword">=</code> <code class="color1">None</code><code class="plain">):</code></div>
<div class="line number52 index51 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="value">0</code></div>
<div class="line number53 index52 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">else</code><code class="plain">:</code></div>
<div class="line number54 index53 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;
</div>
<div class="line number55 index54 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">""" compute the height of each subtree """</code></div>
<div class="line number56 index55 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">lheight </code><code class="keyword">=</code> <code
        class="plain">height(node.left)&nbsp;</code></div>
<div class="line number57 index56 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">rheight </code><code class="keyword">=</code> <code
        class="plain">height(node.right)&nbsp;</code></div>
<div class="line number58 index57 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number59 index58 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">""" use the larger one """</code></div>
<div class="line number60 index59 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">(lheight &gt; rheight):</code></div>
<div class="line number61 index60 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code><code class="plain">(lheight </code><code class="keyword">+</code> <code
        class="value">1</code><code class="plain">)&nbsp;</code></div>
<div class="line number62 index61 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">else</code><code class="plain">:</code></div>
<div class="line number63 index62 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code><code class="plain">(rheight </code><code class="keyword">+</code> <code
        class="value">1</code><code class="plain">)&nbsp;</code></div>
<div class="line number64 index63 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;
</div>
<div class="line number65 index64 alt2"><code class="comments"># Driver Code</code></div>
<div class="line number66 index65 alt1"><code class="keyword">if</code> <code class="plain">__name__ </code><code
        class="keyword">=</code><code class="keyword">=</code> <code class="string">'__main__'</code><code
        class="plain">:</code></div>
<div class="line number67 index66 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">root </code><code class="keyword">=</code> <code class="plain">newNode(</code><code
        class="value">1</code><code class="plain">)&nbsp;</code></div>
<div class="line number68 index67 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">root.left </code><code class="keyword">=</code> <code class="plain">newNode(</code><code
        class="value">2</code><code class="plain">)&nbsp;</code></div>
<div class="line number69 index68 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">root.right </code><code class="keyword">=</code> <code class="plain">newNode(</code><code
        class="value">3</code><code class="plain">)&nbsp;</code></div>
<div class="line number70 index69 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">root.left.left </code><code class="keyword">=</code> <code class="plain">newNode(</code><code
        class="value">7</code><code class="plain">)&nbsp;</code></div>
<div class="line number71 index70 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">root.left.right </code><code class="keyword">=</code> <code class="plain">newNode(</code><code
        class="value">6</code><code class="plain">)&nbsp;</code></div>
<div class="line number72 index71 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">root.right.left </code><code class="keyword">=</code> <code class="plain">newNode(</code><code
        class="value">5</code><code class="plain">)&nbsp;</code></div>
<div class="line number73 index72 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">root.right.right </code><code class="keyword">=</code> <code
        class="plain">newNode(</code><code class="value">4</code><code class="plain">)&nbsp;</code></div>
<div class="line number74 index73 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="functions">print</code><code class="plain">(</code><code
        class="string">"Spiral Order traversal of binary tree is"</code><code class="plain">)&nbsp;</code></div>
<div class="line number75 index74 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">printSpiral(root)&nbsp;</code></div>
<div class="line number76 index75 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;
</div>
<div class="line number77 index76 alt2"><code class="comments"># This code is contributed</code></div>
<div class="line number78 index77 alt1"><code class="comments"># by SHUBHAMSINGH10</code></div>
</div>
</div>
<div id="tab-content-4" class="tab-content">
<div class="container">
<div class="line number1 index0 alt2"><code
        class="comments">// C program for recursive level order traversal in spiral form</code></div>
<div class="line number2 index1 alt1"><code class="preprocessor">#include &lt;stdbool.h&gt;</code></div>
<div class="line number3 index2 alt2"><code class="preprocessor">#include &lt;stdio.h&gt;</code></div>
<div class="line number4 index3 alt1"><code class="preprocessor">#include &lt;stdlib.h&gt;</code></div>
<div class="line number5 index4 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number6 index5 alt1"><code
        class="comments">/* A binary tree node has data, pointer to left child</code></div>
<div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
        class="comments">and a pointer to right child */</code></div>
<div class="line number8 index7 alt1"><code class="keyword bold">struct</code> <code class="plain">node &#123;</code>
</div>
<div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">data;</code></div>
<div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">node* left;</code></div>
<div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">node* right;</code></div>
<div class="line number12 index11 alt1"><code class="plain">&#125;;</code></div>
<div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number14 index13 alt1"><code class="comments">/* Function protoypes */</code></div>
<div class="line number15 index14 alt2"><code class="keyword bold">void</code> <code
        class="plain">printGivenLevel(</code><code class="keyword bold">struct</code> <code
        class="plain">node* root, </code><code class="color1 bold">int</code> <code
        class="plain">level, </code><code class="color1 bold">int</code> <code class="plain">ltr);</code></div>
<div class="line number16 index15 alt1"><code class="color1 bold">int</code> <code class="plain">height(</code><code
        class="keyword bold">struct</code> <code class="plain">node* node);</code></div>
<div class="line number17 index16 alt2"><code class="keyword bold">struct</code> <code
        class="plain">node* newNode(</code><code class="color1 bold">int</code> <code class="plain">data);</code>
</div>
<div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number19 index18 alt2"><code
        class="comments">/* Function to print spiral traversal of a tree*/</code></div>
<div class="line number20 index19 alt1"><code class="keyword bold">void</code> <code
        class="plain">printSpiral(</code><code class="keyword bold">struct</code> <code
        class="plain">node* root)</code></div>
<div class="line number21 index20 alt2"><code class="plain">&#123;</code></div>
<div class="line number22 index21 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">h = height(root);</code></div>
<div class="line number23 index22 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">i;</code></div>
<div class="line number24 index23 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number25 index24 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/*ltr -&gt; Left to Right. If this variable is set,</code></div>
<div class="line number26 index25 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">then the given level is traversed from left to right. */</code></div>
<div class="line number27 index26 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">bool</code> <code class="plain">ltr = </code><code
        class="keyword bold">false</code><code class="plain">;</code></div>
<div class="line number28 index27 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">for</code> <code class="plain">(i = 1; i &lt;= h; i++) &#123;</code></div>
<div class="line number29 index28 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">printGivenLevel(root, i, ltr);</code></div>
<div class="line number30 index29 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number31 index30 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/*Revert ltr to traverse next level in opposite order*/</code></div>
<div class="line number32 index31 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">ltr = !ltr;</code></div>
<div class="line number33 index32 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number34 index33 alt1"><code class="plain">&#125;</code></div>
<div class="line number35 index34 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number36 index35 alt1"><code class="comments">/* Print nodes at a given level */</code></div>
<div class="line number37 index36 alt2"><code class="keyword bold">void</code> <code
        class="plain">printGivenLevel(</code><code class="keyword bold">struct</code> <code
        class="plain">node* root, </code><code class="color1 bold">int</code> <code
        class="plain">level, </code><code class="color1 bold">int</code> <code class="plain">ltr)</code></div>
<div class="line number38 index37 alt1"><code class="plain">&#123;</code></div>
<div class="line number39 index38 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(root == NULL)</code></div>
<div class="line number40 index39 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code><code class="plain">;</code></div>
<div class="line number41 index40 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(level == 1)</code></div>
<div class="line number42 index41 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="functions bold">printf</code><code class="plain">(</code><code class="string">"%d "</code><code
        class="plain">, root-&gt;data);</code></div>
<div class="line number43 index42 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">else</code> <code class="keyword bold">if</code> <code
        class="plain">(level &gt; 1) &#123;</code></div>
<div class="line number44 index43 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(ltr) &#123;</code></div>
<div class="line number45 index44 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">printGivenLevel(root-&gt;left, level - 1, ltr);</code></div>
<div class="line number46 index45 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">printGivenLevel(root-&gt;right, level - 1, ltr);</code></div>
<div class="line number47 index46 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
</div>
<div class="line number48 index47 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">else</code> <code class="plain">&#123;</code></div>
<div class="line number49 index48 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">printGivenLevel(root-&gt;right, level - 1, ltr);</code></div>
<div class="line number50 index49 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">printGivenLevel(root-&gt;left, level - 1, ltr);</code></div>
<div class="line number51 index50 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
</div>
<div class="line number52 index51 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number53 index52 alt2"><code class="plain">&#125;</code></div>
<div class="line number54 index53 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number55 index54 alt2"><code
        class="comments">/* Compute the "height" of a tree -- the number of</code></div>
<div class="line number56 index55 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">nodes along the longest path from the root node</code></div>
<div class="line number57 index56 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">down to the farthest leaf node.*/</code></div>
<div class="line number58 index57 alt1"><code class="color1 bold">int</code> <code class="plain">height(</code><code
        class="keyword bold">struct</code> <code class="plain">node* node)</code></div>
<div class="line number59 index58 alt2"><code class="plain">&#123;</code></div>
<div class="line number60 index59 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(node == NULL)</code></div>
<div class="line number61 index60 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">0;</code></div>
<div class="line number62 index61 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">else</code> <code class="plain">&#123;</code></div>
<div class="line number63 index62 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* compute the height of each subtree */</code></div>
<div class="line number64 index63 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">lheight = height(node-&gt;left);</code></div>
<div class="line number65 index64 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">rheight = height(node-&gt;right);</code></div>
<div class="line number66 index65 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number67 index66 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* use the larger one */</code></div>
<div class="line number68 index67 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(lheight &gt; rheight)</code></div>
<div class="line number69 index68 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">(lheight + 1);</code></div>
<div class="line number70 index69 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">else</code></div>
<div class="line number71 index70 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">(rheight + 1);</code></div>
<div class="line number72 index71 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number73 index72 alt2"><code class="plain">&#125;</code></div>
<div class="line number74 index73 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number75 index74 alt2"><code
        class="comments">/* Helper function that allocates a new node with the</code></div>
<div class="line number76 index75 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
        class="comments">given data and NULL left and right pointers. */</code></div>
<div class="line number77 index76 alt2"><code class="keyword bold">struct</code> <code
        class="plain">node* newNode(</code><code class="color1 bold">int</code> <code class="plain">data)</code>
</div>
<div class="line number78 index77 alt1"><code class="plain">&#123;</code></div>
<div class="line number79 index78 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">node* node = (</code><code
        class="keyword bold">struct</code> <code class="plain">node*)</code></div>
<div class="line number80 index79 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="functions bold">malloc</code><code class="plain">(</code><code
        class="keyword bold">sizeof</code><code class="plain">(</code><code class="keyword bold">struct</code> <code
        class="plain">node));</code></div>
<div class="line number81 index80 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">node-&gt;data = data;</code></div>
<div class="line number82 index81 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">node-&gt;left = NULL;</code></div>
<div class="line number83 index82 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">node-&gt;right = NULL;</code></div>
<div class="line number84 index83 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number85 index84 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">(node);</code></div>
<div class="line number86 index85 alt1"><code class="plain">&#125;</code></div>
<div class="line number87 index86 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number88 index87 alt1"><code class="comments">/* Driver program to test above functions*/</code>
</div>
<div class="line number89 index88 alt2"><code class="color1 bold">int</code> <code class="plain">main()</code></div>
<div class="line number90 index89 alt1"><code class="plain">&#123;</code></div>
<div class="line number91 index90 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">node* root = newNode(1);</code></div>
<div class="line number92 index91 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">root-&gt;left = newNode(2);</code></div>
<div class="line number93 index92 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">root-&gt;right = newNode(3);</code></div>
<div class="line number94 index93 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">root-&gt;left-&gt;left = newNode(7);</code></div>
<div class="line number95 index94 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">root-&gt;left-&gt;right = newNode(6);</code></div>
<div class="line number96 index95 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">root-&gt;right-&gt;left = newNode(5);</code></div>
<div class="line number97 index96 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">root-&gt;right-&gt;right = newNode(4);</code></div>
<div class="line number98 index97 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="functions bold">printf</code><code class="plain">(</code><code
        class="string">"Spiral Order traversal of binary tree is \n"</code><code class="plain">);</code></div>
<div class="line number99 index98 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">printSpiral(root);</code></div>
<div class="line number100 index99 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number101 index100 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">0;</code></div>
<div class="line number102 index101 alt1"><code class="plain">&#125;</code></div>
</div>
</div>
</div>
</div>
<br /> <br /> <br /> <br /> <br />

</div>
    )
}

export default Ola9
